exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-page {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #F4F4F2; }\n\n.app-legal-section {\n  display: flex;\n  align-items: center;\n  margin: 50px 0px 0px; }\n  .app-legal-section .legal-section {\n    flex-grow: 1;\n    justify-content: left;\n    margin-bottom: 0px; }\n  .app-legal-section .ssg-custom-icon-container {\n    flex-shrink: 0;\n    width: 130px; }\n\n.app-legal-section-logo {\n  width: 155px; }\n  .app-legal-section-logo img {\n    width: 100%;\n    height: auto; }\n\n.app-route-content {\n  flex-grow: 1; }\n\n#view {\n  margin-top: 62px;\n  margin-left: 200px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: calc(100% - 62px); }\n  #view.app-hide-nav {\n    margin-left: 0px; }\n\n@media (max-width: 768px) {\n  #view {\n    margin-top: 42px;\n    margin-left: 0px;\n    min-height: calc(100% - 42px); } }\n\n@media (min-width: 300px) {\n  #sidenav + #view {\n    margin-left: 200px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/App.scss
// module id = 632
// module chunks = 0